import { create } from 'zustand';

// const URL = process.env.PUBLIC_URL + "/assets/video/showreel/";
const URL = "https://thekroot.com/assets/video/showreel";

export const useHomeCard = create(() => ({
    data: [
        {
            id: 10,
            name: "main",
            url: "https://www.youtube.com/watch?v=revY_dUkhkc",
            path: `${URL}/main_2025`,
            btnText: "company",
            year: "(2025)",
        },
        {
            id: 9,
            name: "commercial",
            url: "https://www.youtube.com/watch?v=m9zhPKXm1lc&ab_channel=TheKROOT",
            path: `${URL}/commercial_2024`,
            btnText: "commercial",
            year: "(2024)",
        },
        {
            id: 8,
            name: "music",
            url: "https://www.youtube.com/watch?v=0kva06IWbYw&ab_channel=TheKROOT",
            path: `${URL}/music_2024`,
            btnText: "music video",
            year: "(2024)",
        },
        {
            id: 7,
            name: "beauty",
            url: "https://www.youtube.com/watch?v=GXskclwDBCA&ab_channel=TheKROOT",
            path: `${URL}/beauty_2023`,
            btnText: "beauty vfx",
            year: "(2023)",
        },
        {
            id: 6,
            name: "cleanup",
            url: "https://www.youtube.com/watch?v=cedH5onBiWA",
            path: `${URL}/cleanup_2023`,
            btnText: "clean up vfx ",
            year: "(2023)",
        },
        {
            id: 5,
            name: "rotoscoping",
            url: "https://www.youtube.com/watch?v=6e5FLdlb_-k",
            path: `${URL}/rotoscoping_2023`,
            btnText: "rotoscoping",
            year: "(2023)",
        },
        {
            id: 4,
            name: "matchmove",
            url: "https://www.youtube.com/watch?v=PjRnq9_Emhs",
            path: `${URL}/matchmove_2023`,
            btnText: "matchmove",
            year: "(2023)",
        },
        {
            id: 3,
            name: "animation",
            url: "https://www.youtube.com/watch?v=PJwL1OChd0w",
            path: `${URL}/animation_2023`,
            btnText: "2D Animation",
            year: "(2023)",
        },
        {
            id: 2,
            name: "main",
            url: "https://www.youtube.com/watch?v=5gbNqMXN_DU&t=5s",
            path: `${URL}/main_2021`,
            btnText: "company",
            year: "(2021)",
        },
        {
            id: 1,
            name: "animation",
            url: "https://www.youtube.com/watch?v=L-pi7EvpFMI",
            path: `${URL}/animation_2021`,
            btnText: "Animation",
            year: "(2021)",
        },
        {
            id: 0,
            name: "main",
            url: "https://www.youtube.com/watch?v=ZawS1YOq760",
            path: `${URL}/main_2020`,
            btnText: "company",
            year: "(2020)",
        },
    ]
}));
